import React, { useEffect, useState } from "react";
import useModal from "components/modal/useModal";
import { MESSAGE_REGEX } from "helper/helper";
import Modalheader from "components/modal/components/header";
import ModalBody from "components/modal/components/body";
import ModalFooter from "components/modal/components/footer";
import Button from "components/button";
import UseContext from "hooks/useContext";
import StyledInput from "components/styledInput/StyledInput";

const Saisonnier = () => {
    const { data, setData, language } = UseContext();
    const label = (key, defaultValue) =>
        language.getValue(`missionCreation.motifForm.${key}`, defaultValue);
    const [validMotif, setValidMotif] = useState(false);
    // Reopening the modal shows the motif already confirmed, as long as it is this one.
    const [message, setMessage] = useState(() => ({
        type: "5",
        message: data.motif?.type === "5" ? data.motif.message ?? "" : "",
    }));
    const [lengthMessage, setLengthMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState(false);
    const [validMessage, setValidMessage] = useState(false);
    const { toggle } = useModal();
    const verif = message.message.length;

    useEffect(() => {
        setValidMessage(MESSAGE_REGEX.test(message.message));

        if (verif <= 8) {
            setErrorMessage(true);
            setLengthMessage(false);
        } else {
            setErrorMessage(false);
            setLengthMessage(true);
        }
        if (message.motif !== "0") {
            setValidMotif(true);
        } else {
            setValidMotif(false);
        }
    }, [message, verif]);
    const handleMessage = (e) => {
        setMessage({ ...message, message: e.target.value });
    };
    const handleSubmit = () => {
        if (lengthMessage) {
            setData((prevData) => ({ ...prevData, motif: message }));
            toggle();
        }
    };
    return (
        <>
            <Modalheader
                hide={toggle}
                hideShow={true}
                closeLabel={language.getValue("missionCreation.modal.close", "Fermer")}
                description={label("reasonDescriptions.seasonal", "Pour des tâches qui reviennent chaque année à la même période, selon les saisons ou les habitudes de consommation : saison touristique, récoltes, fêtes de fin d'année.")}
            >
                Emploi à caractère saisonnier
            </Modalheader>
            {/*body*/}
            <ModalBody>
                <form className="flex flex-col w-full gap-4">
                    <StyledInput
                        type={"textarea"}
                        placeholder={label("reasonPlaceholders.seasonal", "Ex. : renfort pour la saison touristique, préparation des commandes de Noël…")}
                        label={label("description", "Votre description")}
                        value={message.message}
                        maxLength={250}
                        minLength={10}
                        isLengthInvalid={!!errorMessage}
                        onChange={handleMessage}
                    />
                </form>
            </ModalBody>
            {/*footer*/}
            <ModalFooter>
                <Button size={"LG"} color={"SECONDARY"} onClick={toggle}>
                    Annuler
                </Button>
                <Button size={"LG"} onClick={handleSubmit}>
                    Confirmer
                </Button>
            </ModalFooter>
        </>
    );
};

export default Saisonnier;
